import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { FlightTaskComment } from './FlightTaskComment/FlightTaskComment';
import { SummaryTaskPanel } from './SummaryTaskPanel/SummaryTaskPanel';
import { SummaryBufferCrewPanel } from './SummaryBufferCrewPanel/SummaryBufferCrewPanel';
import { Panel } from '../Panel/Panel';
import { useStyles } from './useStyles';

export const SummaryTaskPage = memo(() => {
    const classes = useStyles();
    const { t: translate } = useTranslation();

    return (
        <div className={classes.summary}>
            <Panel title={translate('labels.flightTaskInfo')} className={classes.legPanel}>
                <SummaryTaskPanel />
                <FlightTaskComment />
            </Panel>
            <SummaryBufferCrewPanel />
        </div>
    );
});
